import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

import { LightsApiService, LightsDevice } from '@shure/shared/angular/features/device-lights-settings/data-access';

@Injectable()
export class DeviceLightsImageNextService {
	constructor(private readonly lightsApiService: LightsApiService) {}

	public getDevice$(deviceId: string): Observable<LightsDevice> {
		return this.lightsApiService.getDevice$(deviceId);
	}
}
